module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(this.item.status == 2) ? _c('span', {
    staticClass: "label-info"
  }, [_vm._v("Wypisany")]) : _vm._e(), _vm._v(" "), (this.item.status == 1) ? _c('span', {
    staticClass: "label"
  }, [_vm._v("Potwierdzony")]) : _vm._e(), _vm._v(" "), (this.item.status == 0) ? _c('span', {
    staticClass: "label-alert"
  }, [_vm._v("Nie potwierdzony")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7816f032","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emails/EmailStatus.vue
// module id = 274
// module chunks = 0